import { default as planModule } from './module/services' 
import { default as planType } from './type/services'
import { default as planChargeType } from './charge-type/services'
import { default as plan } from './plan/services'
import { default as additionalService } from './additional-service/services'
import { default as installment } from './installment/services'

export default { 
	planModule,
	planType,
	planChargeType,
	additionalService,
	installment,
	plan
}
